import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import WmsAccountPage from './account/AccountPage';
import SortingLaborTeamPage from './account/sorting-labor-team/SortingLaborTeamPage';
import { BagsPage } from './bags/BagsPage';
import WmsExceptionPage from './exceptions/WmsExceptionPage';
import ExceptionOrderPage from './exceptionorder/ExceptionOrderPage';
import WmsLocationManagementPage from './location-management/WmsLocationManagementPage';
import WmsParcelsPage from './parcels/WmsParcelsPage';
import DamagedLabelLookupPage from '../damaged-label-lookup/DamagedLabelLookupPage';
import DepartureReviewPage from './review/DepartureReviewPage';
import WorkProgressPage from './progress/work-progress/WorkProgressPage';
import WarehouseStatusPage from './progress/warehouse-status/WarehouseStatusPage';
import ConsolidationTabManager from './consolidation/ConsolidationTabManager';
import DailyTaskMonitoringPage from './delivery/dailyTaskMonitoring/DailyTaskMonitoringPage';
import HubDailyTaskMonitoringPage from './delivery/dailyTaskMonitoring/HubDailyTaskMonitoringPage';
import HubParcelSlaMonitoringPage from './delivery/parcelSlaMonitoring/HubParcelSlaMonitoringPage';
import ParcelSlaMonitoringPage from './delivery/parcelSlaMonitoring/ParcelSlaMonitoringPage';
import DispatchDeliverySummaryPage from './delivery/dispatchDeliverySummary/DispatchDeliverySummaryPage';
// 派送监控大屏原在总部下，挪到 WMS「配送进度」，页面文件仍在 central 目录
import DeliveryMonitorPage from '../central/delivery-monitor/DeliveryMonitorPage';
import DeliveryCompletedSummaryPage from './delivery/deliveryCompletedSummary/DeliveryCompletedSummaryPage';
import InhubDashboardPage from './delivery/inhubDashboard/InhubDashboardPage';
import WmsReportFilePage from './download/WmsReportFilePage';
import RoutesNewPage from '../delivery/routesNew/RoutesNewPage';
import SplitOrderPage from '../delivery/splitOrder/SplitOrderPage';
import RouteAssignPage from '../delivery/routeAssign/RouteAssignPage';
import RoutesHistoryPage from '../delivery/routesHistory/RoutesHistoryPage';
// 直接复用Delivery的AccountsPage组件（司机管理）
import AccountsPage from '../delivery/accounts/AccountsPage';
import { ACCOUNTS_PAGE_MODE } from '../delivery/accounts/hooks/useAccountDeliveryDriverQuery';
// 复用 partner-control 的罚单页面，mode="warehouse" 切到仓库侧只读视图
import PenaltyCenterPage from '../partner-control/penaltyCenter/PenaltyCenterPage';
import PenaltyDetailPage from '../partner-control/penaltyCenter/PenaltyDetailPage';
import WmsLayout from './layouts/WmsLayout';
import DeliveryTaskPage from '../delivery/tasks/DeliveryTaskPage';
import IssueParcelWorkbenchPage from '../delivery/issueParcelWorkbench/IssueParcelWorkbenchPage';
import WmsDspBillListPage from './dsp-bill/WmsDspBillListPage';
import WmsDspBillDetailPage from './dsp-bill/WmsDspBillDetailPage';
import WmsDspPage from './dsp/WmsDspPage';
import MyWorkbenchPage from './workbench/MyWorkbenchPage';
import HubDailyReviewPage from './workbench/HubDailyReviewPage';
import WmsSitesManagementPage from './sites/WmsSitesManagementPage';
import AbAddressManagementPage from './abAddress/AbAddressManagementPage';
import SorterPage from './sorter/SorterPage';
import SorterPlanPage from './sorterPlan/SorterPlanPage';
import SorterPlanDetailRouter from './sorterPlan/SorterPlanDetailRouter';
import SorterPlanDetailPage from './sorterPlan/SorterPlanDetailPage';
import SorterPlanDetailDWSPage from './sorterPlan/SorterPlanDetailDWSPage';
import SorterSortingLogPage from './sorterSortingLog/SorterSortingLogPage';
import { ZipcodesPage } from './zipcode_map_geofence/ZipcodesPage';
import { ZipcodeMapPage } from './zipcode_map_geofence/components/ZipcodeMapPage';
import OrderReprintPage from './order-reprint/OrderReprintPage';
import ClientCartonsPage from './client-cartons/ClientCartonsPage';
import WmsNoUpdateHubPage from './no-update-hub/WmsNoUpdateHubPage';
import WmsNoUpdateWarehousePage from './no-update-warehouse/WmsNoUpdateWarehousePage';
import CutoffPage from './cutoff/CutoffPage';
import TikTokExceptionReportOrderPage from './tt-exception-orders/TikTokExceptionReportOrderPage';
import WmsPodExemptListPage from './podExempt/WmsPodExemptListPage';
import PodExemptReviewWorkbench from '../../components/podExempt/PodExemptReviewWorkbench';

const WmsRoutes: React.FC = () => {
    return (
        <Routes>
            {/* 地图页面独立路由，不使用 WmsLayout */}
            <Route path="/zipcode-map-geofence/map" element={<AuthGuard><ZipcodeMapPage /></AuthGuard>} />
            
            <Route path="/" element={<AuthGuard><WmsLayout /></AuthGuard>}>
                {/*<Route index element={<WmsIndexPage />} />*/}
                <Route path="workbench" element={<MyWorkbenchPage />} />
                <Route path="hub-daily-review" element={<HubDailyReviewPage />} />
                <Route path="bags" element={<BagsPage />} />
                <Route path="progress">
                    <Route index element={<Navigate to="work-progress" replace />} />
                    <Route path="work-progress" element={<WorkProgressPage />} />
                    <Route path="warehouse-status" element={<WarehouseStatusPage />} />
                    <Route path="hub-daily-task-monitoring" element={<HubDailyTaskMonitoringPage />} />
                    <Route path="hub-parcel-sla-monitoring" element={<HubParcelSlaMonitoringPage />} />
                </Route>
                {/* 直接复用Delivery的Routes相关页面，但使用WMS布局 */}
                <Route path="split-order" element={<SplitOrderPage mode="wms" />} />
                <Route path="routes-new" element={<RoutesNewPage />} />
                <Route path="route-assign" element={<RouteAssignPage />} />
                <Route path="routes-history" element={<RoutesHistoryPage mode="wms" />} />
                <Route path="tasks" element={<DeliveryTaskPage mode="wms" />} />
                <Route path="issue-parcel-workbench" element={<IssueParcelWorkbenchPage mode="wms" />} />
                <Route path="parcels" element={<WmsParcelsPage />} />
                <Route path="parcels/damaged-label-lookup" element={<DamagedLabelLookupPage />} />
                <Route path="sorter" element={<SorterPage />} />
                <Route path="sorterPlan" element={<SorterPlanPage />} />
                <Route path="sorterPlan/:id" element={<SorterPlanDetailRouter />} />
                <Route path="sorterPlan/crossbelt/:id" element={<SorterPlanDetailPage />} />
                <Route path="sorterPlan/dws/:id" element={<SorterPlanDetailDWSPage />} />
                <Route path="sorterSortingLog" element={<SorterSortingLogPage />} />
                <Route path="exceptions" element={<WmsExceptionPage />} />
                <Route path="tt-exception-orders" element={<TikTokExceptionReportOrderPage />} />
                <Route path="no-update-hub" element={<WmsNoUpdateHubPage />} />
                <Route path="no-update-warehouse" element={<WmsNoUpdateWarehousePage />} />
                <Route path="exceptionorder" element={<ExceptionOrderPage />} />
                <Route path="location-management" element={<WmsLocationManagementPage />} />
                <Route path="account" element={<WmsAccountPage />} />
                <Route path="account/sorting-labor-team" element={<SortingLaborTeamPage />} />
                <Route path="dsp" element={<WmsDspPage />} />
                <Route path="sites" element={<WmsSitesManagementPage />} />
                <Route path="delivery-driver" element={<AccountsPage mode={ACCOUNTS_PAGE_MODE.WMS} />} />
                <Route path="ab-address" element={<AbAddressManagementPage />} />
                <Route path="review" element={<DepartureReviewPage />} />
                <Route path="delivery/daily-task-monitoring" element={<DailyTaskMonitoringPage mode="whs" />} />
                <Route path="delivery/parcel-sla-monitoring" element={<ParcelSlaMonitoringPage mode="whs" />} />
                <Route path="delivery/delivery-monitor" element={<DeliveryMonitorPage />} />
                <Route path="delivery/delivery-completed-summary" element={<DeliveryCompletedSummaryPage />} />
                <Route path="delivery/dispatch-delivery-summary" element={<DispatchDeliverySummaryPage />} />
                <Route path="delivery/inhub-dashboard" element={<InhubDashboardPage />} />
                <Route path="zipcode-map-geofence" element={<ZipcodesPage />} />
                <Route path="order-reprint" element={<OrderReprintPage />} />
                <Route path="cutoff" element={<CutoffPage />} />
                <Route path="client-cartons" element={<ClientCartonsPage />} />
                <Route path="consolidations" element={<ConsolidationTabManager />} />
                <Route path="penalty-center" element={<PenaltyCenterPage mode="warehouse" />} />
                <Route path="penalty-center/:id" element={<PenaltyDetailPage mode="warehouse" />} />
                <Route path="download" element={<AuthGuard><WmsReportFilePage /></AuthGuard>} />
                <Route path="dsp-bill" element={<WmsDspBillListPage />} />
                <Route path="dsp-bill-detail/:billId" element={<WmsDspBillDetailPage />} />
                <Route path="pod-exempt" element={<WmsPodExemptListPage />} />
                <Route path="pod-exempt/review/:reportId" element={<PodExemptReviewWorkbench role="WHS" />} />
            </Route>
        </Routes>
    );
};

export default WmsRoutes;
